export default __webpack_public_path__ + "static/media/help_24px.cc96ae7d.svg";